module.exports = __webpack_public_path__ + "img/probability_up_kr.6695389b.png";